import React from 'react'
import styles from './index.module.scss'
import logo from "../../../assets/degit.png"

const defaultText = 'Hold on... Take a deep breath...'

interface LoadingPageTransitionProps {
    text?: string
}

const LoadingPageTransition = ({text = defaultText}: LoadingPageTransitionProps) => {
    
    return (
        <div className='flex flex-col items-center justify-center w-full h-full p-1 gap-3'>
            <img src={logo} alt={'Degit Logo'} className={'scale-75'}/>
            <p className='w-fit text-xl'>{text}</p>
            <div className={styles.dotsTyping} />
        </div>
    )
}

export { LoadingPageTransition }